module.exports = __webpack_public_path__ + "static/media/approve-maintenance-alt.9e462c88.svg";